<div
  class="app-container"
  id="kt_app_header_container"
  [ngClass]="headerContainerCssClass"
>
  <div
    class="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
    id="kt_app_header_wrapper"
  >
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="d-flex align-items-center">
        <a routerLink="/client/stores" class="app-logo-link" style="margin-right: 0.5rem;">
          <ng-container *ngIf="currentLayoutType === 'dark-header'">
            <img
              alt="Logo"
              src="./assets/media/logos/logo.png"
              class="h-30px"
            />
          </ng-container>
          <ng-container *ngIf="currentLayoutType !== 'dark-header'">
            <img
              alt="Logo"
              src="./assets/media/logos/logo-black.png"
              class="h-30px theme-light-show"
            />
            <img
              alt="Logo"
              src="./assets/media/logos/logo.png"
              class="h-30px theme-dark-show"
            />
          </ng-container>
        </a>
      
        <div class="d-flex align-items-center" style="margin-left: 0;">
          <ng-container
            *ngIf="appHeaderDefaultContent === 'menu' && appHeaderDefaulMenuDisplay"
          >
            <div
              class="app-header-menu app-header-mobile-drawer align-items-stretch"
              data-kt-drawer="true"
              data-kt-drawer-name="app-header-menu"
              data-kt-drawer-activate="{default: true, lg: false}"
              data-kt-drawer-overlay="true"
              data-kt-drawer-width="225px"
              data-kt-drawer-direction="end"
              data-kt-drawer-toggle="#kt_app_header_menu_toggle"
              data-kt-swapper="true"
              data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
              data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
            >
              <app-header-menu
                class="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0"
                id="kt_app_header_menu"
                data-kt-menu="true"
              ></app-header-menu>
            </div>
          </ng-container>
        </div>
      </div>
      
      <div class="d-flex align-items-center">
        <app-logout-button></app-logout-button>
      </div>
    </div>
  </div>
</div>
